import { Equipment } from '@/api/models/Contracts';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface EquipmentState {
  equipments: Equipment[] | [];
  loading: boolean;
  error: string | null;
}

const initialState: EquipmentState = {
  equipments: [],
  loading: false,
  error: null,
};

const equipmentSlice = createSlice({
  name: 'equipments',
  initialState,
  reducers: {
    // fetchEquipmentRequest: (state) => {
    //   state.loading = true;
    //   state.error = null;
    // },
    fetchEquipmentStart(state, _action: PayloadAction<{ contractId?: string, clientId?: string }>) {
      state.loading = true;
      state.error = null;
    },
    fetchEquipmentSuccess: (state, action: PayloadAction<Equipment[]>) => {
      state.equipments = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchEquipmentFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchEquipmentStart, fetchEquipmentSuccess, fetchEquipmentFailure } =
  equipmentSlice.actions;

export default equipmentSlice.reducer;
